export const gridColumnLayOut = [
  {
    dataField: "transStatusCd",
    headerText: "운송상태",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "wghtDt",
    headerText: "입고일자",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantCd",
    headerText: "사업장",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantNm",
    headerText: "사업장",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "wssId",
    headerText: "계근번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vhclNo",
    headerText: "차량번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrCd",
    headerText: "공급업체 코드",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrNm",
    headerText: "공급업체",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaCd",
    headerText: "상차업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "loadAreaNm",
    headerText: "상차업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "carWeight",
    headerText: "공차중량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "realWeight",
    headerText: "입고중량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageWght",
    headerText: "감량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "dcsnItemCd",
    headerText: "등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dcsnItemNm",
    headerText: "검수등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "itemCd",
    headerText: "사전등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemNm",
    headerText: "사전등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "vhclType",
    headerText: "차량종류",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vhclTypeNm",
    headerText: "차량종류",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "scrapAreaCd",
    headerText: "하차지",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "scrapAreaCdNm",
    headerText: "하차지",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "outageCd",
    headerText: "사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageRsn",
    headerText: "감량사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageRsnNm",
    headerText: "감량사유",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCd",
    headerText: "반품/경고",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCdNm",
    headerText: "반품/경고",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsn",
    headerText: "사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsnNm",
    headerText: "반품사유",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctCd",
    headerText: "감가내역",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctCdNm",
    headerText: "감가내역",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctRate",
    headerText: "감가비율",
    postfix: "%",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctRateNm",
    headerText: "감가비율",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "workerId",
    headerText: "검수자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "workerNm",
    headerText: "검수자",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspNo",
    headerText: "검수번호",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspCd",
    headerText: "검수구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "totalWeight",
    headerText: "총중량",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
];
